<template>
    <div id="container">
        <PlayerBanner ref="PlayerBanners" :isLastStand="isLastStand" v-for="(player, index) in players" :playerData="player" :id="index" :key="player.name+index"/>

    </div>
</template>

<script>
import PlayerBanner from './PlayerBanner.vue'
import {usePlayerStore} from '../store/usePlayerStore.js'
import {storeToRefs} from 'pinia'

export default {
  name: 'PlayersComponent',
  props:{
      isLastStand: Boolean,
    },
    setup(){
        const store = usePlayerStore();
        const { players } = storeToRefs(store);
        return {
            players,
            store
        }
    },
    mounted(){
        window.addEventListener('keyup', (e) =>{
            if(e.code === "Backquote") this.store.addPlayer();
        })
    },
    
    methods:{
        deletePlayer(id){
            
            this.store.deletePlayer(id)
        },
        burnCard(id){
            this.players[id].stackIndex += 1;
        }
    },
    components:{
        PlayerBanner,
    }
}
</script>

<style scoped>
    #container {
        flex: 3;
        align-items: center;
        justify-content: space-evenly;
        display:flex;

        border-width: 0pt;
        border-style: solid;
        border-color: orangered;
    }
</style>